import Color from '@/Enums/Color.enum';
import { Box, Step, StepConnector, Stepper, stepConnectorClasses, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const Connector = styled(StepConnector)({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'currentColor',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'currentColor',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#DCE4E8',
    borderTopWidth: 5,
    borderRadius: '10px',
  },
  [`&.${stepConnectorClasses.root}`]: {
    marginRight: '4px',
  },
});

const getActiveStep = (password = '') => {
  let activeStep = password ? 1 : 0;
  let maxScore = 1;
  const numbers = /[0-9]/g;
  const upperCaseLetters = /[A-Z]/g;
  const minLength = 8;
  const goodLength = 12;

  if (password.length > minLength) {
    activeStep++;
    maxScore = 3;
  }

  if (password.length > goodLength) {
    activeStep++;
    maxScore = 4;
  }

  if (numbers.test(password)) {
    activeStep++;
  }

  if (upperCaseLetters.test(password)) {
    activeStep++;
  }

  return Math.min(activeStep, maxScore);
};

const STEPS = [null, 'Weak', 'Medium', 'Strong', 'Yes'];
const COLORS = [Color.AccentRed, Color.AccentRed, Color.AccentYellow, Color.AccentGreen, Color.Purple];

const PasswordStrengthStepper = ({ password }) => {
  const activeStep = useMemo(() => getActiveStep(password), [password]);

  return (
    <div>
      <div className='text-[#84818A] text-[12px] mb-[8px]'>
        Min 8 characters with a combination of letters and numbers
      </div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          color: COLORS[activeStep],
        }}
      >
        <Stepper
          sx={{
            width: 435,
          }}
          activeStep={activeStep}
          connector={<Connector />}
        >
          {STEPS.map((_step, i) => (
            <Step sx={{ display: 'none' }} key={i} />
          ))}
        </Stepper>
        <span className='font-[Manrope] font-semibold text-[12px]'>{STEPS[activeStep]}</span>
      </Box>
    </div>
  );
};

PasswordStrengthStepper.propTypes = {
  password: PropTypes.string,
};

PasswordStrengthStepper.defaultProps = {
  password: '',
};

export default PasswordStrengthStepper;
